// Demo Firehose API configuration and constants
// 24-hour delayed data for logged-out demo users

export const demoBaseURL =
  import.meta.env.VITE_FIREHOSE_BASE_URL ||
  "https://squawkasaservice.com/api/content-feeds";

export const demoEndpoints = {
  news: "/news-demo",
  newsWithWatchlist: "/news-demo/watchlist",
  sources: "/news-demo/sources",
  stream: "/stream-demo",
};

// Demo sources available (24h delayed)
export const DEMO_SOURCES = [
  "stocks-one",
  "stocks-two",
  "crypto-web-news",
  "energy-x",
  "energy-web-news",
  "fin-x",
  "truth-social",
] as const;

export type DemoSource = (typeof DEMO_SOURCES)[number];

// Demo watchlist tickers (Magnificent 7)
export const DEMO_WATCHLIST_TICKERS = [
  "AAPL",
  "MSFT",
  "GOOGL",
  "AMZN",
  "TSLA",
  "NVDA",
  "META",
] as const;

// Source labels for UI display
export const demoSourceLabels: Record<DemoSource, string> = {
  "stocks-one": "Stocks One",
  "stocks-two": "Stocks Two",
  "crypto-web-news": "Crypto News",
  "energy-x": "Energy X",
  "energy-web-news": "Energy Blogs",
  "fin-x": "Fin X",
  "truth-social": "Truth Social",
};

// Widget ID to demo source mapping
// Used to filter demo content for specific widget types
export const WIDGET_TO_DEMO_SOURCES: Record<string, DemoSource[]> = {
  FirehoseAll: [...DEMO_SOURCES], // All demo sources
  CryptoWeb: ["crypto-web-news"],
  EnergyX: ["energy-x"],
  EnergyWeb: ["energy-web-news"],
  TruthSocial: ["truth-social"],
  FinX: ["fin-x"],
  StocksNews: ["stocks-one", "stocks-two"],
};

/**
 * Helper to check if a source is valid for demo mode
 */
export const isDemoSource = (source: string): source is DemoSource => {
  return (DEMO_SOURCES as readonly string[]).includes(source);
};
